export default __webpack_public_path__ + "static/media/blog1.6d70ddcf.md";